import styled from 'styled-components';

export const CityName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #283618;
  z-index: 1;
  transition: color 0.2s ease;
`;

export const PersonalInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PropertyInformation = styled.div`
  display: grid;
  gap: 1rem;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr); // Two equal columns
    grid-template-rows: repeat(2, auto); // Two rows
    grid-auto-flow: row; // Fill by row
  }

  @media (min-width: 769px) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
    max-width: 780px;
  }
`;
